import { deviceDetector } from './is_mobile'

// Tags an element (in practice <body>) with the device type, so the shared SASS `+on-touch-devices` /
// `+on-non-touch-devices` mixins work. Both frontends need this — the Unpoly app applies it from its
// `body` compiler, the Inertia app from its entrypoint before hydration.
export function addDeviceTypeClass(element: Element = document.body): void {
  if (deviceDetector.isMobile()) {
    element.classList.add('-mobile')
  } else if (deviceDetector.isTablet()) {
    element.classList.add('-tablet')
  } else {
    element.classList.add('-desktop')
  }
}
